import React from "react";
import { AuditOutlined, UserOutlined, IdcardOutlined, ApartmentOutlined, BankOutlined, EuroCircleOutlined, TeamOutlined, KeyOutlined } from "@ant-design/icons";

/******************************************************************
 * ##: Account sections
 * Single source for the account area sections: drives both the nav
 * rail (icon + label) and the page-header breadcrumb (label). The
 * account routes are not part of navigationConfig, so the layout
 * derives the current section label from here for the breadcrumb.
 * `requiresSalespark` gates the bank-accounts section.
 * History:
 * 27-09-2026: Created
 ******************************************************************/
export const ACCOUNT_SECTIONS = [
  { seg: "plan", label: "Plano & Opções", icon: <AuditOutlined /> },
  { seg: "personal-data", label: "Dados Pessoais", icon: <UserOutlined /> },
  { seg: "profile-data", label: "Perfil", icon: <IdcardOutlined /> },
  { seg: "company-data", label: "Dados do Negócio/Empresa", icon: <ApartmentOutlined /> },
  { seg: "financial-data", label: "Contas Bancárias", icon: <BankOutlined />, requiresSalespark: true },
  { seg: "payouts", label: "Saldo & Pagamentos", icon: <EuroCircleOutlined /> },
  { seg: "team-management", label: "Gestão da Equipa", icon: <TeamOutlined /> },
  { seg: "api-tokens", label: "API Tokens", icon: <KeyOutlined /> },
];

/******************************************************************
 * ##: getAccountSection
 * Returns the account section that owns the given pathname (by its
 * trailing segment), or undefined.
 * @param {string} pathname - The current location pathname
 * @returns {object|undefined} - The matching section, or undefined
 * History:
 * 27-09-2026: Created
 ******************************************************************/
export const getAccountSection = (pathname) => ACCOUNT_SECTIONS.find((s) => (pathname || "").endsWith(`/${s.seg}`));
